import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="py-24 px-6 bg-charcoal-800 relative" data-id="element-149">
      <div className="absolute left-0 top-0 bottom-0 w-2 bg-amber" data-id="element-150" />
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <FadeIn data-id="element-152">
          <blockquote className="font-heading text-3xl sm:text-4xl md:text-5xl text-offwhite leading-tight italic" data-id="element-153">
            "En solo 72 horas, vas a pasar de tener el pecho apretado y la
            mandíbula tensa a despertar el lunes con una claridad mental que no
            sentías desde hace años.
            <br data-id="element-154" />
            <br data-id="element-155" />
            <span className="text-amber not-italic" data-id="element-156">
              No es magia, es lo que sucede cuando dejás de intoxicar tu cerebro
              con señales de peligro constantes.
            </span>
            "
          </blockquote>
        </FadeIn>
      </div>
    </section>;
}